import styled from "styled-components";

interface IImage {
  isClickable: boolean;
}

export default styled.img<IImage>`
  cursor: ${(props) => (props.isClickable ? "pointer" : "default")};
`;
